import axios from 'api/axios'
import { ClientProfile } from 'types'
import handleAxiosError from 'utils/handleAxiosError'

/**
 * API call for toggle suspension status of client
 * @param id - id of client to be send to backend for toggle active status of client
 * @returns ClientProfile - Response object returned from the server
 */

export const toggleClientSuspension = async (id: string) => {
	try {
		const { data } = await axios.patch<ClientProfile>(
			`client/account/suspend/${id}`
		)
		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}

export default toggleClientSuspension
